/**
 * Created by zhengyf on 2017/12/28.
 */

;(function () {

    // 装运条款
    var shipmentTerms = [
        'EXW',
        'FAS',
        'FOB',
        'FCA',
        'CFR',
        'CPT',
        'CIF',
        'CIP',
        'DES',
        'DAF',
        'DEQ',
        'DDP',
        'DDU',
        'Express Delivery'
    ];

    // 货币单位
    var monetaryUnit = [
        'USD',
        'GBP',
        'RMB',
        'EUR',
        'AUD',
        'CAD',
        'CHF',
        'JPY',
        'HKD',
        'NZD',
        'SGD',
        'NTD',
        'BRL'
    ];

    //

    var PRICE_RELATED_DATA = {
        // 装运条款
        SHIPMENT_TERMS: [
            'EXW',
            'FAS',
            'FOB',
            'FCA',
            'CFR',
            'CPT',
            'CIF',
            'CIP',
            'DES',
            'DAF',
            'DEQ',
            'DDP',
            'DDU',
            'Express Delivery'
        ],
        // 货币单位
        MONETARY_UNIT: [
            'USD',
            'GBP',
            'RMB',
            'EUR',
            'AUD',
            'CAD',
            'CHF',
            'JPY',
            'HKD',
            'NZD',
            'SGD',
            'NTD',
            'BRL'
        ],
        // 数量单位
        QUANTITY_UNIT: [
            'Pieces',
            '20\' Container',
            '40\' Container',
            '40\' HQ Container',
            'Acre/Acres',
            'Ampere/Amperes',
            'Bags',
            'Barrel/Barrels',
            'Boxes',
            'Bushel/Bushels',
            'Carat/Carats',
            'Carton/Cartons',
            'Case/Cases',
            'Centimeter/Centimeters',
            'Chain/Chains',
            'Cubic Centimeter/Cubic Centimeters',
            'Cubic Foot/Cubic Feet',
            'Cubic Inch/Cubic Inches',
            'Cubic Meter/Cubic Meters',
            'Cubic Yard/Cubic Yards',
            'Degrees Celsius',
            'Degrees Fahrenheit',
            'Dozen/Dozens',
            'Dram/Drams',
            'Fluid Ounce/Fluid Ounces',
            'Foot',
            'Furlong/Furlongs',
            'Gallon/Gallons',
            'Gill/Gills',
            'Grain/Grains',
            'Gram/Grams',
            'Gross',
            'Hectare/Hectares',
            'Hertz',
            'Inch/Inches',
            'Kiloampere/Kiloamperes',
            'Kilogram/Kilograms',
            'Kilohertz',
            'Kilometer/Kilometers',
            'Kiloohm/Kiloohms',
            'Kilovolt/Kilovolts',
            'Kilowatt/Kilowatts',
            'Liter/Liters',
            'Long Ton/Long Tons',
            'Megahertz',
            'Meter',
            'Metric Ton/Metric Tons',
            'Mile/Miles',
            'Milliampere/Milliamperes',
            'Milligram/Milligrams',
            'Millihertz',
            'Milliliter/Milliliters',
            'Millimeter/Millimeters',
            'Milliohm/Milliohms',
            'Millivolt/Millivolts',
            'Milliwatt/Milliwatts',
            'Nautical Mile/Nautical Miles',
            'Ohm/Ohms',
            'Ounce/Ounces',
            'Pack/Packs',
            'Pairs',
            'Pallet/Pallets',
            'Parcel/Parcels',
            'Perch/Perches',
            'Pint/Pints',
            'Plant/Plants',
            'Pole/Poles',
            'Pound/Pounds',
            'Quart/Quarts',
            'Quarter/Quarters',
            'Reams',
            'Rod/Rods',
            'Rolls',
            'Sets',
            'Sheet/Sheets',
            'Short Ton/Short Tons',
            'Square Centimeter/Square Centimeters',
            'Square Feet',
            'Square Meters',
            'Square Inch/Square Inches',
            'Square Mile/Square Miles',
            'Square Yard/Square Yards',
            'Stone/Stones',
            'Strand/Strands',
            'Tonne/Tonnes',
            'Tons',
            'Tray/Trays',
            'Unit/Units',
            'Volt/Volts',
            'Watt/Watts',
            'Wp',
            'Yard/Yards'
        ],
        // 付款方式
        PAYMENT_METHOD: [
            'L/C',
            'T/T',
            'D/P',
            'Western Union',
            'Money Gram',
            'Credit Card',
            'Money Order',
            'Paypal'
        ]
    };

    angular
        .module('app.core')
        .constant('PRICE_RELATED_DATA', PRICE_RELATED_DATA);

})();